import useAdBanner from '@/hooks/ad/useAdBanner';
import { AdPageType } from '@/models/ad/list';
import { appInstallTopBannerState, getAppInstallTopBannerState, hideBanner } from '@/recoil/atoms/cuj/index';
import { Client } from '@/types/app';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';

const useAppInstallTopBanner = (client: Client) => {
  const { isVisible } = useRecoilValue(appInstallTopBannerState);
  const { handleSendExposureLog, bannerAdExchange } = useAdBanner(AdPageType.TopCtaBand, client);

  useEffect(() => {
    getAppInstallTopBannerState();
  }, []);

  return {
    bannerAdExchange,
    handleSendExposureLog,
    isVisible,
    hideBanner,
  };
};

export default useAppInstallTopBanner;
